import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createLogrosProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider[] => {
    const catalogoLogrosProvider: ISearchProvider = {
        key: "logros-catalogo-logros",
        label: "Logros: Catálogo de logros",
        subLabel: "Gestión de logros académicos y extracurriculares",
        action: ctx.navigateModule("logros/logros"),
        search: (): ISearchResult[] => ([]),
    };

    const catalogoCategoriasLogrosProvider: ISearchProvider = {
        key: "logros-catalogo-categorias-logros",
        label: "Logros: Catálogo de categorías de logros",
        subLabel: "Gestión de categorías para logros",
        action: ctx.navigateModule("logros/categorias"),
        search: (): ISearchResult[] => ([]),
    };

    return [
        catalogoLogrosProvider,
        catalogoCategoriasLogrosProvider,
    ];
};